<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>直连经销商管理</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      直连经销商管理
      <div class="title-btn">
        <el-button type="warning" plain @click="openChooseDealer"  v-if="$store.state.funcModuleArray.includes(1901010101)"
          >添加经销商</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card" style="margin-bottom: 20px;">
        <el-form :inline="true" size="small">
          <el-form-item label="状态筛选">
            <el-select v-model="form.status" placeholder="选择状态">
              <el-option
                v-for="(item, index) in statusList"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-input
              placeholder="请输入经销商编码/经销商名称"
              v-model="form.find_value"
              class="input-with-select"
            >
              <el-button slot="append" @click="onSearch">搜索</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card">
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="client_code" label="经销商编码" width="180">
            </el-table-column>
            <el-table-column prop="name" label="经销商名称" width="180">
              <template slot-scope="scope">
                <div class="dealer-name-wrapper">
                  <span class="dealer-name">{{ scope.row.name }}</span>
                  <el-tag 
                    v-if="scope.row.is_new === 1" 
                    class="new-tag"
                    size="small"
                  >新</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="plugin_code" label="插件编码">
              <template slot-scope="scope">
                <span v-if="scope.row.is_untying === 1">{{
                  scope.row.plugin_code
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="client_plugin_name" label="用户名">
            </el-table-column>
            <el-table-column prop="client_plugin_password" label="密码">
            </el-table-column>
            <el-table-column prop="status_text" label="状态"> </el-table-column>
            <el-table-column label="操作" v-if="$store.state.funcModuleArray.includes(1901010102) || $store.state.funcModuleArray.includes(1901010103)">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="
                    openDialog('rowEdit', {
                      row: scope.row,
                      index: scope.$index
                    })
                  "
                  type="text"
                  size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010102)"
                >
                  编辑
                </el-button>
<!--                <el-divider-->
<!--                  direction="vertical"-->
<!--                  v-if="scope.row.is_untying === 0 && $store.state.funcModuleArray.includes(1901010103)"-->
<!--                ></el-divider>-->
<!--                <el-button-->
<!--                  v-if="scope.row.is_untying === 0 && $store.state.funcModuleArray.includes(1901010103)"-->
<!--                  @click.native.prevent="rowDelete(scope.$index, scope.row)"-->
<!--                  type="text"-->
<!--                  size="small"-->
<!--                >-->
<!--                  删除-->
<!--                </el-button>-->
                <el-divider
                  v-if="scope.row.is_untying === 1 && $store.state.funcModuleArray.includes(1901010103)"
                  direction="vertical"
                ></el-divider>
                <el-button
                  v-if="scope.row.is_untying === 1 && $store.state.funcModuleArray.includes(1901010103)"
                  @click.native.prevent="rowUnbind(scope.$index, scope.row)"
                  type="text"
                  size="small"
                >
                  解绑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <choose-dealer
      ref="chooseDealer"
      @saveChange="clientAddSaveChange"
      :is-checkbox="true"
      :is-clear-search-text="true"
    ></choose-dealer>
    <!--    编辑-->
    <el-dialog title="编辑" :visible.sync="dialog.rowEdit.visible">
      <el-form
        ref="rowEditForm"
        :model="rowEditForm"
        :rules="rowEditRules"
        label-width="96px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="rowEditForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="rowEditForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.rowEdit.visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rowEditSave('rowEditForm')"
          :loading="dialog.rowEdit.isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog.configmForce.visible" :width="'500px'">
      {{ dialog.configmForce.msg }}
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.configmForce.visible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="onDirectConnectionClient(1)"
          :loading="dialog.configmForce.isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChooseDealer from "@/components/ChooseDealer";
import {
  getClientConnect,
  clientSetNamePwd,
  directConnectionClient,
  delClient,
  unbindClient
} from "@/api/index";

export default {
  name: "DirectDealerManage",
  components: {
    ChooseDealer
  },
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    dialog: {
      rowEdit: {
        visible: false,
        isLoading: false,
        row: {}
      },
      configmForce: {
        visible: false,
        msg: "",
        isLoading: false
      }
    },
    rowEditForm: {
      username: "",
      password: ""
    },
    rowEditRules: {
      username: [
        { required: false, message: "请输入用户名", trigger: "blur" },
        { max: 50, message: "最多50个字符", trigger: "blur" }
      ],
      password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        {
          pattern: /\d+/g,
          message: "必须包含数字"
        },
        {
          pattern: /[a-z]+/g,
          message: "必须包含小写字母"
        },
        {
          pattern: /[A-Z]+/g,
          message: "必须包含大写字母"
        },
        {
          pattern: /[\.\@\!\#\$\%\^\&\*\(\)\-\_]+/gi,
          message: "必须包含特殊字符：@!#$%^&*()-_"
        },
        {
          min: 6,
          max: 16,
          message: "密码长度为6到16位"
        }
      ]
    },
    tableData: [],
    form: {
      find_value: "",
      status: ""
    },
    statusList: [
      { value: "全部", key: "" },
      { value: "正常", key: "1" },
      // { value: "已解绑", key: "2" },
      { value: "已取消安装", key: "3" }
    ],
    connectionClientParameter: {} //添加经销商的时候 传的参数
  }),
  created() {
    this._getList(1);
  },
  methods: {
    _getList(page) {
      let param = { ...this.form };
      param.page = page;
      getClientConnect(param).then(res => {
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    openDialog(dialogName, e) {
      this.dialog[dialogName].visible = true;
      if (e) {
        this.dialog[dialogName].e = { ...e };
        // 编辑
        if (dialogName === "rowEdit") {
          if (this.$refs["rowEditForm"]) {
            this.$refs["rowEditForm"].resetFields();
          }
          this.rowEditForm = {
            username: e.row.client_plugin_name,
            password: e.row.client_plugin_password
          };
        }
      }
    },
    openChooseDealer() {
      this.$refs.chooseDealer.openDialog();
    },
    rowEditSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialog.rowEdit.isLoading = true;
          const e = this.dialog.rowEdit.e;
          const clientId = e.row.client_id;

          let values = { ...this[formName] };
          clientSetNamePwd(clientId, values.username, values.password).then(
            res => {
              this.dialog.rowEdit.isLoading = false;
              if (0 === res.status) {
                this.dialog.rowEdit.visible = false;
                this.tableData[e.index].client_plugin_name = values.username;
                this.tableData[e.index].client_plugin_password =
                  values.password;
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        }
      });
    },
    clientAddSaveChange(selectionVal) {
      let clientIds = [];
      for (let item of selectionVal) {
        clientIds.push(item.client_id);
      }
      this.connectionClientParameter = {
        client_id: clientIds.join(",")
      };
      this.onDirectConnectionClient();
    },
    onDirectConnectionClient(is_force_set = 0) {
      let parameters = {
        client_id: this.connectionClientParameter.client_id,
        is_force_set
      };
      this.dialog.configmForce.isLoading = true;
      directConnectionClient(parameters).then(res => {
        this.dialog.configmForce = {
          visible: false,
          msg: "",
          isLoading: false
        }
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this._getList(1);
        } else if (res.status == 4) {
          this.dialog.configmForce = {
            visible: true,
            msg: res.msg,
            isLoading: false
          };
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    rowDelete(index, row) {
      this.$confirm(
        "是否删除该经销商，删除后该档案所登录的插件将不会再抓取数据",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          delClient(row.client_id).then(res => {
            if (0 === res.status) {
              // this.tableData.splice(index, 1);
              this._getList(this.currentPage);
              this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    rowUnbind(index, row) {
      this.$confirm(
        "是否解除这个经销商与这个插件的绑定关系？解绑后登陆了这个账号的插件将不会再执行抓取服务",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          unbindClient(row.client_id).then(res => {
            if (0 === res.status) {
              // this.tableData[index].status = 0;
              // this.$set(this.tableData,index,this.tableData[index]);
              this._getList(this.currentPage);
              this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑"
          });
        });
    },
    onSearch() {
      this._getList(1);
    }
  }
};
</script>

<style scoped>
.dealer-name-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dealer-name {
  flex: 1;
  word-wrap: break-word;
  word-break: break-all;
}

.new-tag {
  flex-shrink: 0;
  color: white;
  background-color: #409EFF;
}
</style>
